/* tslint:disable */
import {Injectable} from '@angular/core';
import {environment} from "../environments/environment";
import {Observable} from "rxjs";
import {UserService} from "./atlas/user-management/user.service";
import {HttpClient} from "@angular/common/http";
import {AlertService} from "./alert.service";

@Injectable({
    providedIn: 'root'
})
export class SharedService {
    //Change for testing the new ROI branch

    constructor(private http: HttpClient,
                private userService: UserService,
                private alertService:AlertService) {
        window['mediaURL'] = environment.mediaURL;
    }

    downloadFile_old(filePath, fileName) {
        const fullUrl = environment.mediaURL + filePath;
      
        fetch(fullUrl)
          .then(response => {
            if (!response.ok) throw new Error('Network error');
            return response.blob();
          })
          .then(blob => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
          })
          .catch(error => {
            console.error('Download failed:', error);
          });
    }

    downloadFile(filePath: string, fileName: string) {
        const fileUrl = environment.mediaURL + filePath;

        // Make a HEAD request to check if the file exists
        this.http.head(fileUrl, {observe: 'response'}).subscribe({
            next: (response) => {
                if (response.status === 200) {
                    const a = document.createElement('a');
                    a.href = fileUrl;
                    a.target = '_blank';
                    a.download = fileName;

                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                }
            },
            error: (err) => {
                // Show warning message here
                this.alertService.showWarningMsg("The requested file does not exist or could not be downloaded.");
            }
        });
    }

    uploadFile(fileToUpload: File, url: string, additionalData: { [key: string]: any } = {}): Observable<any> {
        const formData: FormData = new FormData();
        formData.append('file', fileToUpload, fileToUpload.name);
        formData.append('userID', this.userService.user.id);

        // Append additional data to formData
        Object.keys(additionalData).forEach(key => {
            formData.append(key, additionalData[key]);
        });

        return this.http.post(`${url}/`, formData);
    }

    uploadFileOptions(fileToUpload: File, markerName = '') {
        const formData: FormData = new FormData();
        formData.append('file', fileToUpload, fileToUpload.name);
        formData.append('userID', this.userService.user.id);
        if (markerName) {
            formData.append('markerName', markerName);
        }
        return {
            method: 'POST',
            body: formData,
        };


        // return this.http.post(`${url}/`, formData);

    }

    uploadS3File(fileToUpload: File, url, fileType): Observable<any> {

        const formData: FormData = new FormData();
        formData.append('file', fileToUpload, fileToUpload.name);
        formData.append('fileType', fileType);

        return this.http.post(`${url}/`, formData);
    }

    reloadPage(routerLink) {
        location.href = routerLink;

    }

    getPartOfString(str, fromIndex, toIndex) {
        return str.substring(fromIndex, toIndex);
    }

    isBetween(x, min, max) {
        return x >= min && x <= max;
    }

    copyTextToClipboard(val: string) {
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = val;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
    }


}
